(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-how-it-works"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
    const stepCarouel = $('.step-carousel')
    stepCarouel.slick({
        speed:500,
        arrows: false,
        dots: true,
        responsive: [
        {
            breakpoint: 768,
            settings: {
              adaptiveHeight: true,
              dots: true
            }
          }
        ]         
    });

    $('.step-nav-img').on('click',function(){
        $('.step-nav').removeClass('active');
        let slideIndex = $(this).data('slick-slide');
        console.log(slideIndex);
        $('.step-nav-img[data-slick-slide="'+slideIndex+'"').parent().addClass('active');
        stepCarouel.slick('slickGoTo',parseInt(slideIndex));
    });
    $(".arrow-left").click(function(e) {
        e.preventDefault();
        stepCarouel.slick("slickPrev"); 
      });
    $(".arrow-right").click(function(e) {
        e.preventDefault();
        stepCarouel.slick("slickNext");
    });
    
    stepCarouel.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.step-nav').removeClass('active');
        $('.step-nav img[data-slick-slide="'+nextSlide+'"').parent().addClass('active');
    });    
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-testimonials"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
    const testimonialCarouel = $('.testimonial-carousel');
    let getSliderSettings = () => {
        return {
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            responsive: [
            {
                breakpoint: 768,
                settings: {
                  arrows: false,
                  centerMode: true,
                  dots: true,
                  slidesToShow: 1
                }
              }
            ]   
        }
    }
    testimonialCarouel.slick(getSliderSettings());
    $(".testimonial-arrow-left").click(function(e) {
        e.preventDefault();
        testimonialCarouel.slick("slickPrev"); 
      });
      $(".testimonial-arrow-right").click(function(e) {
        e.preventDefault();
        testimonialCarouel.slick("slickNext");
      });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-video"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
    $('.video-cover').on('click',function(){
        $(this).hide();
        $('.video-wrapper iframe').css('display','block');
    });
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how_it_works_aboutus"]) return;
  try {
    
$(document).ready(function(){
  $('.slider').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    dots:false,
    arrows:false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
		  dots: true
        }
      }
    ]
  });
})

  } catch(e) { console.error(e); }
})();
})();
